theme.headerSticky = (function() {
  function ScrollSticky(){
    const target = document.querySelector('.header__sticky');
    if(!target) return;
    const holder = target.parentElement;
    let graense = 0;
    function opdater(){
      target.classList.toggle('sticky', window.scrollY > graense);
    }
    function maal(){
      const var_fast = target.classList.contains('sticky');
      if(var_fast) target.classList.remove('sticky');
      holder.style.minHeight = target.offsetHeight + 'px';
      graense = target.getBoundingClientRect().top + window.scrollY;
      opdater();
    }
    window.addEventListener('scroll', opdater, { passive: true });
    window.addEventListener('resize', maal);
    window.addEventListener('load', maal);
    maal();
  }
  return ScrollSticky;
})();
